import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Helpers from '../helpers/util';

import * as actionCreators from '../actions/actionCreators';
import SeverityLevel from './SeverityLevel';

class Featured extends React.Component {
	constructor() {
		super();

		this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
		this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
		this.mouseClickHandler = this.mouseClickHandler.bind(this);
	}
	mouseLeaveHandler() {
		this.props.hoverFeatured({});
	}
	mouseEnterHandler() {
		this.props.hoverFeatured(this.props.country);
	}
	mouseClickHandler(name) {
		this.props.hoverFeatured({});
		
		if (window.vaxihub) {
			const eventName = 'custom.event.travel_map--top_destination_click'; // Created inside GTM
			const eventField = 'custom.event.travel_map--top_destination'; // Created inside GTM
			const eventObject = Helpers.GTM.create(eventName, {
				[eventField]: `${name} - Vaccine Hub Top Destination`
			});
			Helpers.GTM.push(eventObject);
		}
	}
	render() {
		const country = this.props.country;
		const style = {
			backgroundImage: `url(${country.image})`
		};
		return (
			<Link
				to={`/travel/${country.ISO.toLowerCase()}`}
				onClick={() => {
					this.mouseClickHandler(country.name);
				}}
				onMouseLeave={this.mouseLeaveHandler}
				onMouseEnter={this.mouseEnterHandler}
				className="featured-list-item"
			>
				<div className="featured-list-thumb" style={style} />
				<div className="featured-list-text">
					<div className="featured-list-title">{country.name}</div>
					<SeverityLevel level={country.level} />
					<span className="featured-list-arrow">
						<span className="icon icon-featured-arrow" />
					</span>
				</div>
			</Link>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(actionCreators, dispatch);
}

export default connect(
	null,
	mapDispatchToProps
)(Featured);
